import Tables from 'src/class/Tables';
import i18n from 'src/i18n';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'code_station',
      minWidth: 120,
      label: i18n.t('devices.station_code'),
      sortable: true,
      fixed: true,
    },
    {
      prop: 'station',
      label: i18n.t('devices.station'),
      minWidth: 120,
      sortable: true,
      fixed: true,
    },
    {
      prop: 'formatted_date',
      label: i18n.t('common_words.time_interval'),
      minWidth: 120,
      sortable: true,
      fixed: true,
    },
  ];

  return { Table };
};

export default configTable;
